export type SiteBuilderIconCategory = "emoji" | "icons" | "social";

export type SiteBuilderIconCatalogItem = {
    category: SiteBuilderIconCategory;
    id: string;
    preview: string;
    value: string;
};

export const SITE_BUILDER_ICON_CATALOG: readonly SiteBuilderIconCatalogItem[] = [
    { category: "icons", id: "check", preview: "✓", value: "lucide:check" },
    { category: "icons", id: "heart", preview: "♡", value: "lucide:heart" },
    { category: "icons", id: "truck", preview: "↦", value: "lucide:truck" },
    { category: "icons", id: "store", preview: "▦", value: "lucide:store" },
    { category: "icons", id: "shield", preview: "⬟", value: "lucide:shield" },
    { category: "icons", id: "creditCard", preview: "▭", value: "lucide:creditCard" },
    { category: "icons", id: "info", preview: "i", value: "lucide:info" },
    { category: "icons", id: "bag", preview: "▱", value: "lucide:bag" },
    { category: "icons", id: "mail", preview: "@", value: "lucide:mail" },
    { category: "icons", id: "phone", preview: "☎", value: "lucide:phone" },
    { category: "icons", id: "mapPin", preview: "⌖", value: "lucide:mapPin" },
    { category: "icons", id: "search", preview: "⌕", value: "lucide:search" },
    { category: "icons", id: "user", preview: "●", value: "lucide:user" },
    { category: "icons", id: "home", preview: "⌂", value: "lucide:home" },
    { category: "icons", id: "navigation", preview: "⌁", value: "lucide:navigation" },
    { category: "icons", id: "briefcase", preview: "▣", value: "lucide:briefcase" },
    { category: "icons", id: "rotate", preview: "↻", value: "lucide:rotate" },
    { category: "icons", id: "chevronRight", preview: "›", value: "lucide:chevronRight" },
    { category: "icons", id: "utensils", preview: "♨", value: "lucide:utensils" },
    { category: "icons", id: "leaf", preview: "⌁", value: "lucide:leaf" },
    { category: "icons", id: "wine", preview: "♧", value: "lucide:wine" },
    { category: "icons", id: "car", preview: "◈", value: "lucide:car" },
    { category: "icons", id: "wrench", preview: "⌕", value: "lucide:wrench" },
    { category: "icons", id: "gauge", preview: "◔", value: "lucide:gauge" },
    { category: "icons", id: "scanLine", preview: "⌗", value: "lucide:scanLine" },
    { category: "icons", id: "batteryCharging", preview: "↯", value: "lucide:batteryCharging" },
    { category: "icons", id: "disc3", preview: "◎", value: "lucide:disc3" },
    { category: "icons", id: "music", preview: "♫", value: "lucide:music" },
    { category: "icons", id: "calendarDays", preview: "▦", value: "lucide:calendarDays" },
    { category: "icons", id: "calendarCheck", preview: "✓", value: "lucide:calendarCheck" },
    { category: "icons", id: "clock", preview: "◷", value: "lucide:clock" },
    { category: "icons", id: "martini", preview: "▽", value: "lucide:martini" },
    { category: "icons", id: "images", preview: "▣", value: "lucide:images" },
    { category: "icons", id: "radio", preview: "◉", value: "lucide:radio" },
    { category: "icons", id: "zap", preview: "ϟ", value: "lucide:zap" },
    { category: "emoji", id: "sparkles", preview: "✨", value: "emoji:✨" },
    { category: "emoji", id: "fire", preview: "🔥", value: "emoji:🔥" },
    { category: "emoji", id: "gift", preview: "🎁", value: "emoji:🎁" },
    { category: "emoji", id: "star", preview: "⭐", value: "emoji:⭐" },
    { category: "emoji", id: "rocket", preview: "🚀", value: "emoji:🚀" },
    { category: "emoji", id: "smile", preview: "🙂", value: "emoji:🙂" },
    { category: "emoji", id: "leaf", preview: "🌿", value: "emoji:🌿" },
    { category: "emoji", id: "zap", preview: "⚡", value: "emoji:⚡" },
    { category: "social", id: "facebook", preview: "f", value: "social:facebook" },
    { category: "social", id: "instagram", preview: "◎", value: "social:instagram" },
    { category: "social", id: "youtube", preview: "▶", value: "social:youtube" },
    { category: "social", id: "x", preview: "𝕏", value: "social:x" },
    { category: "social", id: "linkedin", preview: "in", value: "social:linkedin" },
    { category: "social", id: "whatsapp", preview: "W", value: "social:whatsapp" },
    { category: "social", id: "pinterest", preview: "p", value: "social:pinterest" },
    { category: "social", id: "email", preview: "@", value: "social:email" },
    { category: "social", id: "tiktok", preview: "♪", value: "social:tiktok" },
    { category: "social", id: "link", preview: "↗", value: "social:link" },
];
